import { configureStore } from '@reduxjs/toolkit'
import albumsReducer from '../containers/albums/meta/slices';

export default configureStore({ 
        reducer: {
            album:albumsReducer
        }
})


